<template>
  <div class="has-text-left ltr">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">First Name :</label>
          <div class="control">
            <input
              class="input is-info"
              type="text"
              v-model.trim="fields.first_name"
              placeholder="Please enter first name ..."
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Last Name :</label>
          <div class="control">
            <input
              class="input is-info"
              type="text"
              v-model.trim="fields.last_name"
              placeholder="Please enter last name ..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Email :</label>
          <div class="control">
            <input
              class="input is-info"
              type="email"
              v-model.trim="fields.email"
              placeholder="Please enter e-mail ..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Phone number :</label>
          <div class="control">
            <input
              class="input is-info"
              type="text"
              v-model.trim="fields.phone_number"
              placeholder="Please enter phone number ..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Password :</label>
          <div class="control">
            <input
              class="input is-info"
              type="password"
              v-model="fields.password"
              placeholder="password ..."
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Confirm Pasword :</label>
          <div class="control">
            <input
              class="input is-info"
              type="password"
              v-model="fields.confirm_password"
              placeholder="password ..."
            />
          </div>
        </div>
      </div>
    </div>
    <div class="field is-grouped is-grouped-right modal_footer">
      <p class="control">
        <button
          class="button is-info"
          :class="{ 'is-loading': is_submitting }"
          @click="onSubmit"
        >
          Submit
        </button>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      fields: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '',
        confirm_password: ''
      },
      is_submitting: false
    }
  },
  methods: {
    async onSubmit () {
      try {
        if (this.fields.password != this.fields.confirm_password) {
          this.$utils.emit('show_toast', { text: "The password don't match the conformation" })
        }
        const token = await this.$network_utils.registerPlain(this.fields)
        await this.$network_utils.updateUserDetails({ ...this.fields, token: token.auth_token })
        this.$utils.emit('show_toast', { text: 'The applicant was created succesfull' })
        for (let prop in this.fields) {
          this.fields[prop] = ''
        }
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'Problem with applicant creation, please try later' })
      }
    }
  }
}
</script>

<style scoped>

</style>
